import { has } from "lodash";
import * as React from "react";
import {useState, useContext, createContext} from 'react';
import useSet from "../components/hooks/useSet";

const QuoteContext = createContext({
  products:null, 
  setProducts: null,
  addingProduct: null,
  setAddingProduct: null,
  allCategories: null,
  setAllCategories: null,
  services:null, 
  setServices: null,
  addingService: null,
  setAddingService: null,
  charges:null,
  setCharges: null,
  addingCharge: null, 
  setAddingCharge: null,
  showHistory: null,
  setShowHistory: null,
  history: null,
  setHistory: null,
  seeAllProducts: null,
  setSeeAllProducts: null,
  seeAllServices:null,
  setSeeAllServices: null,
  seeAllCharges: null,
  setSeeAllCharges: null,
  seeAllPServices: null,
  setSeeAllPServices: null,
  soldString: null,
  setSoldString: null,
  hasCw: null,
  setHasCw: null,
  cwCompany: null,
  setCwCompany: null,
  cwId: null,
  setCwId: null,
  companyModal: null,
  setCompanyModal: null,
  subtype:null,
  setSubtype: null,
  serviceExpense: null,
  setServiceExpense: null,
  serviceHours: null,
  setServiceHours: null,
  productExpense: null,
  setProductExpense: null,
  chargeExpense: null,
  setChargeExpense: null,
  projectLaborRevenue: null,
  setProjectLaborRevenue: null,
  projectLaborExpense: null,
  setProjectLaborExpense: null,
  quoteSubmitted: null,
  setQuoteSubmitted: null,
  chargesOnlyExpense: null,
  setChargesOnlyExpense: null
});

export const QuoteProvider = ({children}) => {
  const [products, setProducts] = useState([]);
  const [addingProduct, setAddingProduct] = useState(false);
  const [allCategories, setAllCategories] = useState([])
  const [services, setServices] = useState([])
  const [addingService, setAddingService] = useState(false)
  const [charges, setCharges] = useState([])
  const [addingCharge, setAddingCharge] = useState(false)
  const [showHistory, setShowHistory] = useState(false)
  const [history, setHistory] = useState([])
  const [seeAllProducts, setSeeAllProducts] = useState(false)
  const [seeAllServices, setSeeAllServices] = useState(false)
  const [seeAllCharges, setSeeAllCharges] = useState(false)
  const [seeAllPServices, setSeeAllPServices] = useState(false)
  const [soldString, setSoldString] = useState('')
  const [hasCw, setHasCw] = useState(false)
  const [cwCompany, setCwCompany] = useState(null)
  const [cwId, setCwId] = useState(null)
  const [companyModal, setCompanyModal] = useState(false)
  const [subtype, setSubtype] = useState(null)
  // display cost for each per mikes request
  // service, product & charge cost
  const [serviceExpense, setServiceExpense] = useState(0)
  const [serviceHours, setServiceHours] = useState(0)
  const [productExpense, setProductExpense] = useState(0)
  const [chargeExpense, setChargeExpense] = useState(0)
  const [projectLaborRevenue, setProjectLaborRevenue] = useState(0)
  const [projectLaborExpense, setProjectLaborExpense] = useState(0)
  const [quoteSubmitted, setQuoteSubmitted] = useState(false)
  const [chargesOnlyExpense, setChargesOnlyExpense] = useState(0)

  return (
    <QuoteContext.Provider 
      value={{
        products:products, 
        setProducts: setProducts,
        addingProduct: addingProduct,
        setAddingProduct: setAddingProduct,
        allCategories: allCategories,
        setAllCategories: setAllCategories,
        services: services,
        setServices: setServices,
        addingService:addingService,
        setAddingService: setAddingService,
        charges: charges,
        setCharges: setCharges,
        addingCharge: addingCharge,
        setAddingCharge: setAddingCharge,
        showHistory: showHistory,
        setShowHistory: setShowHistory,
        history: history,
        setHistory: setHistory,
        seeAllProducts:seeAllProducts,
        setSeeAllProducts:setSeeAllProducts,
        seeAllServices: seeAllServices,
        setSeeAllServices: setSeeAllServices,
        seeAllCharges: seeAllCharges,
        setSeeAllCharges: setSeeAllCharges,
        seeAllPServices:seeAllPServices,
        setSeeAllPServices: setSeeAllPServices,
        soldString: soldString,
        setSoldString: setSoldString,
        hasCw: hasCw,
        setHasCw: setHasCw,
        cwCompany: cwCompany,
        setCwCompany: setCwCompany,
        cwId: cwId,
        setCwId: setCwId,
        companyModal: companyModal,
        setCompanyModal: setCompanyModal,
        subtype: subtype,
        setSubtype: setSubtype,
        serviceExpense: serviceExpense,
        setServiceExpense: setServiceExpense,
        serviceHours: serviceHours,
        setServiceHours: setServiceHours,
        productExpense: productExpense,
        setProductExpense: setProductExpense,
        chargeExpense: chargeExpense,
        setChargeExpense: setChargeExpense,
        projectLaborRevenue: projectLaborRevenue,
        setProjectLaborRevenue: setProjectLaborRevenue,
        projectLaborExpense: projectLaborExpense,
        setProjectLaborExpense: setProjectLaborExpense,
        quoteSubmitted: quoteSubmitted,
        setQuoteSubmitted: setQuoteSubmitted,
        chargesOnlyExpense: chargesOnlyExpense,
        setChargesOnlyExpense: setChargesOnlyExpense
      }}
    >
      {children}
    </QuoteContext.Provider>
  )
};

export default function useQuote() {
  return useContext(QuoteContext);
}


// WEBPACK FOOTER //
// ./app/javascript/hooks/useQuote.tsx